// ***********************************
// Add.vue
// ***********************************
<template>
  <div id="app">
    <div>
        <router-link :to="{ name: 'Main'}">List</router-link> | 
        <router-link :to="{ name: 'Add'}">Add</router-link> |
        <router-link :to="{ name: 'Profile' }">Share</router-link> 
      </div>
    <div class="container">
      <b-alert :show="showAlert" :variant="alertStyle">{{alertText}}
      <div v-show="showAlert && alertStyle=='success'">
          <router-link :to="{ name: 'Main' }">Click here to continue</router-link>
      </div>
      </b-alert>

      <b-card v-if="!showAlert" header="Add a single database">
        Switch to the <router-link :to="{ name: 'BatchAdd'}">add multiple databases in a single batch</router-link> feature.<br/><br/>

        If you are looking to send an email to the customer, you can use this as a starting point:<br/>
        <b-form-textarea id="textarea-plaintext" :value="sampleEmail" rows="8" size="sm"></b-form-textarea>
<br/><br/>
        <b-list-group>
          <b-list-group-item>
            <div>
              <b>First, select the type of database you are investigating.</b>
              <p/>
              <b-form-select v-model="selected" class="mb-3">
                <option value="null">Please select your database type</option>
                <option value="ora_v1">Oracle Enterprise Edition with Diagnostics Pack</option>
                <option value="ora_stat_v1">Oracle Standard or Enterprise Edition with STATSPACK</option>
                <!--<option value="msft_v1" disabled>Microsoft SQL Server</option>-->
              </b-form-select>
            </div>
          </b-list-group-item>
          <b-list-group-item>
            <div>
              <b>Second, download the data collection script for your database type.</b>
              <b-card bg-variant="light" v-if="(selected=='ora_v1')">
                Download the DBCSI Diagnostics Pack data collection script from
                <a
                  href="/aws_awr_miner.sql" target="_blank"
                >here</a>.
              </b-card>
              <b-card bg-variant="light" v-if="(selected=='ora_stat_v1')">
                Download the DBCSI STATSPACK data collection script from
                <a
                  href="/aws_statspack_miner.sql" target="_blank"
                >here</a>.
              </b-card>
              <b-card bg-variant="light" v-if="(selected=='msft_v1')">
                Download the Microsoft SQL Server data collection script from
                <a
                  href="/dbcsi_sqlserver.sql" target="_blank"
                >here</a>.  NOTE THAT SQL SERVER SUPPORT IS STILL A WORK-IN-PROGRESS.
              </b-card>
            </div>
          </b-list-group-item>
          <b-list-group-item>
            <div>
              <b>Third, run the script against your database; the script will generate an output file.</b>
              <b-card
                bg-variant="light"
                v-if="(selected=='ora_v1')"
              >Instructions: Use sql*plus to run this script as a database user with the select_catalog_role (i.e. with SELECT privileges on the DBA_*, v$*, and gv$* tables/views).
              <br>
              </b-card>
              <b-card
                bg-variant="light"
                v-if="(selected=='ora_stat_v1')"
              >
                At this point, you should have already installed STATSPACK in your database (typically by running $ORACLE_HOME/rdbms/admin/spcreate.sql) and setup automated regular STATSPACK data collection jobs (typically by running $ORACLE_HOME/rdbms/admin/spauto.sql, and do so on each instance if running RAC).  For more details about STATSPACK, review $ORACLE_HOME/rdbms/admin/spdoc.txt
                <br>
                <br>
                Instructions: Use sql*plus to run the data collection script as an user (such as PERFSTAT) who has access to the STATSPACK STATS$ tables and the data dictionary.
              </b-card>
              <b-card
                bg-variant="light"
                v-if="(selected=='msft_v1')"
              >
                Instructions: STAY TUNED.  THIS INFORMATION TO BE UPDATED SHORTLY.
              </b-card>
            </div>
          </b-list-group-item>
          <b-list-group-item>
            <div>
              <b>Fourth, provide some additional details about your database and upload your data collection output file.</b>
              <b-card bg-variant="light" class="text-left" v-if="((selected=='ora_v1')||(selected=='ora_stat_v1'))">
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                  <b-form-group
                    id="exampleInputGroup1"
                    label="Database Name:"
                    label-for="db_name"
                    description="Human-friendly name for this database."
                  >
                    <b-form-input
                      id="db_name"
                      type="text"
                      v-model="form.db_name"
                      required
                      placeholder="Enter database name"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group id="exampleInputGroup4" label="Description:" label-for="descr">
                    <b-form-textarea
                      id="descr"
                      v-model="form.descr"
                      required
                      placeholder="Enter a description for this database.  Describe applications supported by this database."
                      :rows="3"
                      :max-rows="6"
                    ></b-form-textarea>
                  </b-form-group>
                  <b-form-group id="exampleInputGroup2" label="Customer Name:" label-for="customer">
                    <b-form-input
                      id="customer"
                      type="text"
                      v-model="form.customer"
                      required
                      placeholder="Enter customer name."
                      list="my-list-id">
                    </b-form-input>
                    <datalist id="my-list-id">
                      <option v-for="(item, index) in this.CustomerChoices" :key="index">{{ item.value }}</option>
                    </datalist>
                  </b-form-group>
                  
                  <b-form-group
                    id="exampleInputGroup5"
                    label="Select the data collection output file to be uploaded."
                    label-for="output_file"
                  >
                    <b-form-file
                      id="output_file"
                      ref="fileinput"
                      v-model="output_file"
                      :state="Boolean(output_file)"
                      required
                      placeholder="Choose a file... This must be the output file created by the DBCSI script (.out, or a .zip/.gz containing a single .out file).  Do not upload an AWR Report."
                      @change="onFileChange"
                    ></b-form-file>
                    
                    <b-alert :show="showFileAlert" :variant="alertFileVariant">{{alertFileText}}</b-alert>
                    <img src="@/assets/warning.png" height="14px" ></img>Reminder: always use the most recent DBCSI data collection script (available to download above) for the latest features and fixes.
                    <br/><img src="@/assets/warning.png" height="14px" ></img>Tip: If you have multiple databases to upload, you can use the <router-link :to="{ name: 'BatchAdd'}">add multiple databases in a single batch</router-link> feature.<br/><br/>

  
                    
                    <!-- <div class="mt-3">Selected file: {{output_file && output_file.name}}</div> -->
                  </b-form-group>
                  
                  <b-alert variant="danger" :show="showSampleAlert">The "sample" user is not allowed to upload new databases.  Please sign-out and create your own user.</b-alert>

                  <b-button type="submit" :disabled="showFileAlertError || showSampleAlert" variant="primary">Submit</b-button>
                  <b-button type="reset" variant="danger">Reset</b-button>
                </b-form>
              </b-card>
              <b-card bg-variant="light" class="text-left" v-if="((selected=='msft_v1'))">
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                  <b-form-group
                    id="exampleInputGroup1"
                    label="Instance Name:"
                    label-for="db_name"
                    description="Human-friendly name for this instance."
                  >
                    <b-form-input
                      id="db_name"
                      type="text"
                      v-model="form.db_name"
                      required
                      placeholder="Enter instance name"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group id="exampleInputGroup4" label="Description:" label-for="descr">
                    <b-form-textarea
                      id="descr"
                      v-model="form.descr"
                      required
                      placeholder="Enter a description for this instance.  Describe applications supported by this instance."
                      :rows="3"
                      :max-rows="6"
                    ></b-form-textarea>
                  </b-form-group>
                  <b-form-group id="exampleInputGroup2" label="Customer Name:" label-for="customer">
                    <b-form-input
                      id="customer"
                      type="text"
                      v-model="form.customer"
                      required
                      placeholder="Enter customer name."
                      list="my-list-id">
                    </b-form-input>
                    <datalist id="my-list-id">
                      <option v-for="(item, index) in this.CustomerChoices" :key="index">{{ item.value }}</option>
                    </datalist>
                  </b-form-group>
                  
                  <b-form-group
                    id="exampleInputGroup5"
                    label="Select the data collection output file to be uploaded."
                    label-for="output_file"
                  >
                    <b-form-file
                      id="output_file"
                      ref="fileinput"
                      v-model="output_file"
                      :state="Boolean(output_file)"
                      required
                      placeholder="Choose a file... This must be the output file created by the DBCSI script (.out, or a .zip/.gz containing a single .out file)."
                      @change="onFileChange"
                    ></b-form-file>
                    
                    <b-alert :show="showFileAlert" :variant="alertFileVariant">{{alertFileText}}</b-alert>
                    
                    <!-- <div class="mt-3">Selected file: {{output_file && output_file.name}}</div> -->
                  </b-form-group>
                
                  <b-alert variant="danger" :show="showSampleAlert">The "sample" user is not allowed to upload new databases.  Please sign-out and create your own user.</b-alert>

                  <b-button type="submit" :disabled="showFileAlertError || showSampleAlert" variant="primary">Submit</b-button>
                  <b-button type="reset" variant="danger">Reset</b-button>
                </b-form>
              </b-card>
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </div>
  </div>
</template>    


<script>
/* global DecompressionStream */
import { API, Storage, Auth } from "aws-amplify";
export default {
  name: "app",
  props: ["user"],
  data() {
    return {
      selected: null,
      output_file: null,
      form: {
        db_name: "",
        customer: "",
        descr: ""
      },
      isUploading: false,
      show: true,
      showAlert: false,
      showFileAlert: false,
      showSampleAlert: false,
      showFileAlertError: false,      
      alertText: "",
      alertStyle: "default",
      alertFileText: "",
      alertFileVariant: "danger", // danger = blocks submit, warning = may proceed, info = informational only
      CustomerChoices: [
          { value: 'Customer1', text: 'Customer1' },
      ],
      sampleEmail: "Here is the DBCSI data collection SQL*Plus script we discussed today: https://dbcsi.d29q8g3b9hzyur.amplifyapp.com/aws_awr_miner.sql\n\nThis script assumes you are running Oracle Enterprise Edition with the Diagnostics Pack (as the script queries the AWR tables).  If you are not licensed for EE and the Diagnostics Pack, do NOT run the aws_awr_miner.sql script but you can instead run a script that works together with the Oracle STATSPACK utility to collect performance metrics on any edition of Oracle.  Find our STATSPACK-based script here: https://dbcsi.d29q8g3b9hzyur.amplifyapp.com/aws_statspack_miner.sql\n\nUse SQL*Plus to run the aws_awr_miner.sql script as a database user with the select_catalog_role (i.e. SELECT privileges on the DBA_*, v$*, and gv$* tables/views).  The script will create a .out file which we can use for analysis.  Feel free to review the script and the generated output file- it will only collect performance metrics and does not collect sql statement text, table names, table data, etc.\n\nIf you are looking for an easy way to run the script against multiple databases, we have a zip file that includes a simple shell script to loop through a list of databases and run the script against each.  You can download the zip file to run against multiple databases at once from here: https://dbcsi.d29q8g3b9hzyur.amplifyapp.com/batch_ora.zip\n\nOnce you are done, you can email us the output file(s).  If email does not want to work (some systems have restrictions on attachments), let us know.\n\nFinally, you can find some additional information here: https://dbcsi.d29q8g3b9hzyur.amplifyapp.com/DBCSI_AWR_and_STATSPACK_Miner_Instructions.pdf"
    };
  },
  async created() {
    // console.log("Add: I am here1");
    let name = await Auth.currentAuthenticatedUser();
    this.user = name.username;
    // console.log("this.user", this.user);
    if (this.user=="sample") {
      this.showSampleAlert = true;
    }
    
    var tries = 10;
    while (tries > 0) {
      await API.get("dbcsiAPI", `/dbcsi/customers`)
        .then(response => {
          // console.log("Add: I am here3");
          //use .shift() to remove the first row
          var filteredItems = response.data.filter(item => item.value !== 'xxALL');
          this.CustomerChoices = filteredItems;
          tries = 0;
          // console.log(this.genItems);
        })
        .catch(error => {
          console.log("Add Error:", error);
          console.log("Will retry.  Attempts Left:", (tries-1));
        });

      tries -= 1;
    }
    
    await API.get(
        "dbcsiAPI",
        `/dbcsi/permissions`
      )
        .then(response => {
          if (response.data.racOK=="Y") {
            // console.log("Authorized for RAC.");      
            // this.showRAC = true;
          }
        })
        .catch(error => {
          console.log("Add-permissions Error:", error);
        });

    
  },
  
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventNav);
    });
  },

  beforeRouteLeave (to, from , next) {
    if (this.isUploading) {
      if (!window.confirm("Do you really want to leave? The upload is not finished yet and you will lose it!")) {
        console.log("Add: Not OK to Leave");
        return;
      }
    }
    next();
  },
  
  methods: {
    preventNav(event) {
      if (!this.isUploading) return;
      console.log("Add: preventNav: Not OK to Leave");
      event.preventDefault();
      // Chrome requires returnValue to be set.
      event.returnValue = "";
    },

    async onFileChange(e) {
      /* https://www.raymondcamden.com/2019/05/21/reading-client-side-files-for-validation-with-vuejs */
      const file = e.target.files[0];
      if(!file ) {
        console.error("onFileChange: no file");
        this.alertFileText = "You need to select a file to upload.";
        this.showFileAlert = true;
        this.showFileAlertError = true;        
        this.alertFileVariant = "danger";
        return;
      }
      // the S3 lambda unpacks a .zip holding a single file or a .gz, so peek inside those the same way
      let upload;
      try {
        upload = await this.readUploadPrefix(file);
      } catch (err) {
        console.log("onFileChange: unable to read upload:", err);
        this.alertFileText = err.message;
        this.showFileAlert = true;
        this.showFileAlertError = !err.allowProceed;
        this.alertFileVariant = err.allowProceed ? "warning" : "danger";
        return;
      }
      this.checkFileContents(upload.text);
      this.alertFileVariant = this.showFileAlertError ? "danger" : (this.showFileAlert ? "warning" : "info");
      if (upload.note && !this.showFileAlertError) {
        this.alertFileText = upload.note + (this.showFileAlert ? "  " + this.alertFileText : "");
        this.showFileAlert = true;
      }
    },

    /*
     * Summary: read the first 64KB of text from an upload, looking inside .gz and single-file .zip uploads.
     * Returns: {text, note} where note is a message to show the user (or null).
     *   Throws Error with a user-facing message; err.allowProceed=true means a warning rather than a block.
     */
    async readUploadPrefix(file) {
      const MAX_BYTES = 65536;
      const head = new Uint8Array(await file.slice(0, 6).arrayBuffer());
      const startsWith = (bytes) => bytes.every((b, i) => head[i] === b);
      const canDecompress = typeof DecompressionStream !== "undefined";
      const cannotCheck = (msg) => Object.assign(new Error(msg), { allowProceed: true });

      if (startsWith([0x37, 0x7A, 0xBC, 0xAF, 0x27, 0x1C])) {
        throw new Error("This is a 7-Zip file, which DBCSI cannot read.  Please extract the .out file and upload it directly (or use a standard .zip file).");
      }

      if (startsWith([0x1F, 0x8B])) {
        if (!canDecompress) {
          throw cannotCheck("This is a .gz file.  Your browser cannot look inside it, so it cannot be checked before upload.  DBCSI will decompress it after upload.");
        }
        const bytes = await this.readStreamPrefix(file.stream().pipeThrough(new DecompressionStream("gzip")), MAX_BYTES);
        return { text: this.decodeText(bytes), note: null };
      }

      if (startsWith([0x50, 0x4B, 0x03, 0x04]) || startsWith([0x50, 0x4B, 0x05, 0x06])) {
        const entries = await this.listZipEntries(file);
        // same files the S3 lambda ignores: folders, __MACOSX, sqlplus.log, and the miner's one-line helper script dbcsi_miner_check.sql
        const ignored = ["sqlplus.log", "dbcsi_miner_check.sql"];
        const files = entries.filter(z => !z.name.endsWith("/") && z.name.indexOf("__MACOSX") < 0 && !ignored.includes(z.name.split("/").pop()));
        if (files.length != 1) {
          throw new Error(`This .zip file contains ${files.length} files.  When adding a single database, the .zip must contain exactly one DBCSI output file.  To upload multiple databases, use the "add multiple databases in a single batch" feature.`);
        }
        const entry = files[0];
        const note = `This .zip file contains ${entry.name}, which DBCSI will extract after upload.`;
        if (entry.encrypted) {
          throw new Error("This .zip file is password protected, which DBCSI cannot read.  Please upload the .out file directly.");
        }
        if ((entry.method != 0 && entry.method != 8) || (entry.method == 8 && !canDecompress)) {
          throw cannotCheck(note + "  Its contents cannot be checked in this browser before upload.");
        }
        // local file header: 30 bytes + name + extra field, then the compressed data
        const lh = new DataView(await file.slice(entry.localOffset, entry.localOffset + 30).arrayBuffer());
        const dataStart = entry.localOffset + 30 + lh.getUint16(26, true) + lh.getUint16(28, true);
        let stream = file.slice(dataStart, dataStart + entry.compressedSize).stream();
        if (entry.method == 8) {
          stream = stream.pipeThrough(new DecompressionStream("deflate-raw"));
        }
        let bytes = await this.readStreamPrefix(stream, MAX_BYTES);
        if (entry.name.endsWith(".gz")) {
          if (!canDecompress) {
            throw cannotCheck(note + "  Its contents cannot be checked in this browser before upload.");
          }
          bytes = await this.readStreamPrefix(new Blob([bytes]).stream().pipeThrough(new DecompressionStream("gzip")), MAX_BYTES);
        }
        return { text: this.decodeText(bytes), note: note };
      }

      return { text: this.decodeText(new Uint8Array(await file.slice(0, MAX_BYTES).arrayBuffer())), note: null };
    },

    /*
     * Summary: list a .zip file's entries by reading its central directory (only the end of the file is read).
     * Returns: array of {name, method, compressedSize, localOffset, encrypted}
     */
    async listZipEntries(file) {
      const notReadable = new Error("This looks like a .zip file but it could not be read (it may be damaged or use an unsupported zip format).  Please upload the .out file directly.");
      // the end-of-central-directory record is 22 bytes plus an optional comment of up to 64KB
      const tailStart = Math.max(0, file.size - 65557);
      const tail = new DataView(await file.slice(tailStart).arrayBuffer());
      let eocd = -1;
      for (let p = tail.byteLength - 22; p >= 0; p--) {
        if (tail.getUint32(p, true) == 0x06054B50) { eocd = p; break; }
      }
      if (eocd < 0) throw notReadable;
      const count = tail.getUint16(eocd + 10, true);
      const cdSize = tail.getUint32(eocd + 12, true);
      const cdOffset = tail.getUint32(eocd + 16, true);
      if (count == 0xFFFF || cdOffset == 0xFFFFFFFF) throw notReadable; // zip64
      const cd = new DataView(await file.slice(cdOffset, cdOffset + cdSize).arrayBuffer());
      const entries = [];
      let p = 0;
      for (let n = 0; n < count; n++) {
        if (p + 46 > cd.byteLength || cd.getUint32(p, true) != 0x02014B50) throw notReadable;
        const nameLen = cd.getUint16(p + 28, true);
        entries.push({
          name: new TextDecoder().decode(new Uint8Array(cd.buffer, p + 46, nameLen)),
          encrypted: (cd.getUint16(p + 8, true) & 1) == 1,
          method: cd.getUint16(p + 10, true),
          compressedSize: cd.getUint32(p + 20, true),
          localOffset: cd.getUint32(p + 42, true)
        });
        p += 46 + nameLen + cd.getUint16(p + 30, true) + cd.getUint16(p + 32, true);
      }
      return entries;
    },

    // read up to maxBytes from a ReadableStream, then stop
    async readStreamPrefix(stream, maxBytes) {
      const reader = stream.getReader();
      const chunks = [];
      let total = 0;
      try {
        while (total < maxBytes) {
          const { done, value } = await reader.read();
          if (done) break;
          chunks.push(value);
          total += value.length;
        }
      } finally {
        reader.cancel().catch(() => {});
      }
      const out = new Uint8Array(total);
      let pos = 0;
      for (const c of chunks) { out.set(c, pos); pos += c.length; }
      return out.subarray(0, maxBytes);
    },

    // decode bytes as text; UTF-16LE (with BOM) is accepted because the S3 lambda converts it
    decodeText(bytes) {
      if (bytes[0] == 0xFF && bytes[1] == 0xFE) {
        return new TextDecoder("utf-16le").decode(bytes.subarray(2));
      }
      return new TextDecoder("utf-8").decode(bytes);
    },

    // check that the (unpacked) text looks like a DBCSI data collection file
    checkFileContents(text) {
        if (this.selected == "msft_v1") {
          if (text.substring(0,20).indexOf('host_name')>=0) {
            this.alertFileText = "";
            this.showFileAlert = false;
            this.showFileAlertError = false;              
          } else {
            this.alertFileText = "This is not a DBCSI data collection file.  Please review Steps 2 and 3 above.";
            this.showFileAlert = true;
            this.showFileAlertError = true;                   
            console.log("Not a DBCSI data collection file.  We expect to see host_name.  Instead we see:");
            console.log(text.substring(0,40));
          }  
          
        } else {
          
          if (text.substring(0,200).indexOf('~~BEGIN-OS')>=0) {
            if ((text.substring(0,4000).indexOf('4.0.11.aws.')>=0) || (text.substring(0,4000).indexOf('4.0.11.statspack.')>=0)){
              this.alertFileText = "";
              this.showFileAlert = false;
              this.showFileAlertError = false;
              
              //second check.  if statspack, make sure STATSPACK_SNAPSHOTS is >10
              if (text.substring(0,4000).indexOf('4.0.11.statspack.')>=0) {
                let myPos = text.substring(0,4000).indexOf('STATSPACK_SNAPSHOTS');
                let myString = text.substring(myPos+61,myPos+66).split(/\r?\n/)[0];
                console.log("STATSPACK_SNAPSHOTS", myString);
                if ( (myString*1)<10 ) {
                  this.alertFileText = "It looks like you only have "+myString*1+" STATSPACK snapshots collected.  You should have at least 10 snapshots at a minimum for DBCSI to work.  Please collect more STATSPACK snapshots in your database and re-run the data collection script.";
                  this.showFileAlert = true;
                  this.showFileAlertError = false;
                  console.log("It looks like you only have "+myString*1+" STATSPACK snapshots collected.  You should have at least 10 snapshots at a minimum for DBCSI to work well.");
                }
              }
            } else {  
              this.alertFileText = "This output file does not appear to have been created using the latest DBCSI script (it might be created using a different version/fork of the original AWR Miner script).  You can still upload this file, but your results may vary and it may not work.  It would be best if you download and run the DBCSI script from Step 2 above.";
              this.showFileAlert = true;
              this.showFileAlertError = false;
              console.log("Not a DBCSI data collection file.  We expect to see AWR_MINER_VER of 4.0.11.aws or 4.0.11.statspack.  Instead we see:");
              console.log(text.substring(0,4000));
            }  
          } else {
            this.alertFileText = "This is not a DBCSI data collection file.  Please review Steps 2 and 3 above.";
            this.showFileAlert = true;
            this.showFileAlertError = true;
            console.log("Not a DBCSI data collection file.  We expect to see ~~BEGIN-OS-INFORMATION~~.  Instead we see:");
            console.log(text.substring(0,200));
          }  
        }  
    },
    async onSubmit(evt) {
      let dbtype = "Oracle";
      if (this.selected == "msft_v1") {
        dbtype = "Microsoft";
      }

      evt.preventDefault();
      let collection_type = this.selected;
      this.selected = null;
      this.alertStyle="primary"
      this.alertText = "Uploading data collection output file... Please wait... Do not leave this page yet.";
      this.showAlert = true;
      this.isUploading = true;
      // console.log("Add: I am here1");
      var tries = 10;
      var success = false;
  /*    while (tries > 0) {
        await API.get("dbcsiAPI", `/dbcsi/collections`)
          .then(response => {
            // console.log("Add: Aurora is ready");
            //   this.collection_list = response.data;
            tries = 0;
            success = true;
          })
          .catch(error => {
            console.log("Add.vue API Error (Aurura asleep? can retry):", error);
            console.log("Will retry.  Attempts Left:", (tries-1));
          });

        tries -= 1;
      } */
      success = true;
      if (success) {
        // console.log("Add: I am here4");
        //do a put to /collections
        const putParams = {
          body: {
            db_name: this.form.db_name,
            db_type: dbtype,
            customer: this.form.customer,
            descr: this.form.descr,
            collection_type: collection_type
          }
        };

        var new_id = null;
        var api_success = false;
        await API.put("dbcsiAPI", `/dbcsi/collections`, putParams)
          .then(response => {
            new_id = response.data.collection_id;
            api_success = true;
            // console.log("Add API.put: new collection_id=", new_id);
          })
          .catch(error => {
            console.log("Add API.put Error:", error);
            // alert("API.put error");
              this.alertText = "Database put error.";
              this.alertStyle="danger";
              this.isUploading = false;
          });

        if (api_success) {
          await Storage.put(
            `collection_${new_id}_metrics.out`,
            this.output_file
          )
            .then(result => {
              console.log("Add Storage.put: ", result);
              this.alertText = "File uploaded successfully.";
              this.alertStyle="success";
              this.isUploading = false;

            })
            .catch(err => {
              console.log("Add Storage.put Error:", err);
            //   alert("Storage.put error");
              this.alertText = "File upload error.";
              this.alertStyle="danger";
              this.isUploading = false;
            });
        }
      }

      //   alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form.db_name = "";
      this.form.customer = "";
      this.form.descr = "";
      this.output_file = null;
      this.$refs.fileinput.reset();
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>

<style>
</style>
